<script>
import Utils from '@/common/Utils';


export default{
  props: ['label', 'uom', 'value', 'hideUom'],
  components: {},
  data(){
    return {
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    }
  }
}

</script>

<template>
  <main>
    <div class="grid">
        <div class="col-6" style="font-weight: bold;font-size: 1.2rem;">{{ label }}</div>
        <div class="col-2" v-if="!hideUom" style="font-size: 1.2rem;">{{ uom }}</div>
        <div :class="{'col-4': !hideUom, 'col-6': hideUom}" style="display: flex;justify-content: end;font-size: 1.2rem;">{{ value }}</div>
    </div>
  </main>
</template>